// extracted by mini-css-extract-plugin
export default {"starsCell":"StarsCell_starsCell__BATvT","starsNumber":"StarsCell_starsNumber__en1WP","starIcon":"StarsCell_starIcon__F-Dft"};